
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoaurangabadinnovacab() {



    const cardData =
    {
        keyword: 'Pune to Aurangabad Innova Cab ',
        heading: 'S9 Travels: Pune to Aurangabad Innova Cab ',
        headingDescription: 'S9 Travels offers premium Innova cab services for travelers going from Pune to Aurangabad. Whether you’re visiting historical monuments, temples, or simply need a comfortable ride, our fleet of well-maintained Innovas provides a safe, reliable, and luxurious travel experience. The distance between Pune and Aurangabad is approximately 230 km, and the journey typically takes around 4.5 to 5 hours by road. With S9 Travels, enjoy a smooth and relaxing ride to explore one of Maharashtra’s most culturally rich cities.',

        top: 'Top Places to Visit in Aurangabad with S9 Travels',

"topPlaces": [
    {
      "title": "Ajanta Caves",
      "description": "The Ajanta Caves are a UNESCO World Heritage Site, known for their ancient rock-cut Buddhist temples, exquisite paintings, and sculptures. Dating back to the 2nd century BCE, these caves are a must-visit for history and art enthusiasts."
    },
    {
      "title": "Ellora Caves",
      "description": "Another UNESCO World Heritage Site, the Ellora Caves is a complex of 34 monasteries and temples carved into the basalt rock. The caves are famous for the Kailasa Temple, a single monolithic rock excavation. It’s an exceptional display of ancient Indian architecture and art."
    },
    {
      "title": "Bibi Ka Maqbara",
      "description": "Bibi Ka Maqbara, often referred to as the 'Taj of the Deccan,' is a beautiful mausoleum built by Azam Shah in memory of his mother, Rabia-ud-Daurani. The structure is an architectural marvel, with its stunning resemblance to the Taj Mahal."
    },
    {
      "title": "Daulatabad Fort",
      "description": "Daulatabad Fort is an impressive historical fort located about 15 km from Aurangabad. It was once the capital of the Yadava dynasty. The fort is famous for its strategic location, robust walls, and the challenging climb to the top, offering panoramic views of the surrounding area."
    },
    {
      "title": "Grishneshwar Temple",
      "description": "Grishneshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and is an important pilgrimage site for Hindus. The temple, located near Ellora, is known for its beautiful architecture and spiritual significance."
    },
    {
      "title": "Panchakki (Water Mill)",
      "description": "Panchakki is a historic water mill built in the 17th century. It was designed to grind grains using water from a nearby stream. The site is known for its innovative water distribution system and the peaceful surroundings, making it a nice spot for a visit."
    },
    {
      "title": "Aurangabad Caves",
      "description": "The Aurangabad Caves are a group of 12 Buddhist caves located on a hilltop in the city. These caves, dating back to the 6th and 7th centuries, are known for their carvings, sculptures, and rock-cut temples."
    },
    {
      "title": "Siddharth Garden and Zoo",
      "description": "Siddharth Garden is a tranquil garden perfect for families and nature lovers. It also has a zoo, where visitors can see a variety of animals. It’s a great place for a relaxing day out."
    },
    {
      "title": "Chini Ka Rauza",
      "description": "Chini Ka Rauza is a beautiful tomb located in Aurangabad, which displays Indo-Persian architecture. The tomb is known for its intricate tile work and is dedicated to a Persian scholar who was a minister at the Mughal court."
    },
    {
      "title": "Jalna",
      "description": "Located about 50 km from Aurangabad, Jalna is known for its beautiful temples, including the Renuka Mata Temple and the Gajanan Maharaj Temple. It is also famous for its vibrant agricultural landscape."
    }
],

"services": [
    {
      "name": "Pune to Aurangabad Innova Cab Service",
      "description": "Traveling from Pune to Aurangabad? Book an Innova cab for a comfortable and convenient journey. Whether it's a one-way trip or a round trip, our Innova cabs are the perfect choice to make your travel smooth and enjoyable."
    },
    {
      "name": "Book Innova for Pune to Aurangabad",
      "description": "Booking an Innova taxi for your trip to Aurangabad is simple and hassle-free. Whether you're traveling with family, friends, or colleagues, our Innova cabs offer ample space, comfort, and reliability for the long drive."
    },
    {
      "name": "Pune to Aurangabad Innova Taxi",
      "description": "Our Pune to Aurangabad Innova taxis are well-maintained, offering a safe and comfortable ride. Enjoy a smooth journey with ample legroom, air-conditioning, and expert drivers who ensure a relaxed trip."
    },
    {
      "name": "Pune to Aurangabad Innova One-Way",
      "description": "If you need a one-way taxi from Pune to Aurangabad, our Innova cabs are the best option. Book your one-way ride with us and enjoy a direct, comfortable trip to your destination without any worries."
    },
    {
      "name": "Pune to Aurangabad Round Trip Innova",
      "description": "For those looking for a round-trip service, we offer round-trip Innova cabs from Pune to Aurangabad. Whether you're planning to explore the city or visit temples, our round-trip service gives you flexibility and convenience."
    },
    {
      "name": "Pune to Aurangabad Innova Car Hire",
      "description": "Rent an Innova for your trip from Pune to Aurangabad and enjoy a stress-free journey. We provide flexible car hire options for your convenience, making your travel experience comfortable and enjoyable."
    },
    {
      "name": "Innova Cabs for Aurangabad Trip",
      "description": "Planning a trip to Aurangabad? Our Innova cabs are perfect for visiting historical sites like the Ellora and Ajanta Caves, Bibi Ka Maqbara, and other local attractions. Book your Innova cab now and enjoy a sightseeing trip in comfort."
    },
    {
      "name": "Affordable Aurangabad Innova Service",
      "description": "Looking for an affordable yet comfortable ride to Aurangabad? Our Innova cabs offer great value for money, providing you with an affordable solution for your long-distance travel needs without compromising on comfort."
    },
    {
      "name": "Innova Taxi for Aurangabad from Pune",
      "description": "Book a private Innova taxi for your trip from Pune to Aurangabad. With spacious interiors, a smooth ride, and professional drivers, your journey will be comfortable and relaxing."
    },
    {
      "name": "Luxury Innova Cab to Aurangabad",
      "description": "For a more luxurious experience, choose our premium Innova service to Aurangabad. Offering a plush ride with top-notch features, our luxury Innova cabs ensure a comfortable and stylish journey."
    },
    {
      "name": "Group Booking for Aurangabad Innova",
      "description": "Traveling with a group? Our Innova cabs can comfortably accommodate up to 7 passengers, making it the perfect choice for family, friends, or corporate groups. Book your group trip to Aurangabad now!"
    },
    {
      "name": "Pune to Aurangabad One-Way Taxi",
      "description": "Enjoy the convenience of a one-way taxi service from Pune to Aurangabad with our reliable Innova cabs. You can book the service online, and we'll ensure you reach your destination without any hassle."
    },
    {
      "name": "Aurangabad Temple Innova Tour",
      "description": "Aurangabad is home to many temples and historical sites. Book an Innova cab for a temple tour in Aurangabad, and our professional drivers will guide you to popular sites like the Grishneshwar Temple and Ellora Caves."
    },
    {
      "name": "Innova for Aurangabad Travel",
      "description": "Whether you're visiting for a leisure trip or exploring historical sites, our Innova cabs provide a comfortable and reliable option for your Aurangabad travel. Enjoy the ride while we take care of the details."
    },
    {
      "name": "Pune to Aurangabad Innova Booking",
      "description": "Booking your Innova taxi from Pune to Aurangabad has never been easier. With just a few clicks, you can secure your ride and enjoy a comfortable, stress-free journey. Book your Innova taxi now for a hassle-free trip."
    }
  ],

"tableData": [
  ["Pune to Aurangabad Innova Cab", "Book Innova for Pune to Aurangabad"],
  ["Pune to Aurangabad Innova Taxi", "Pune to Aurangabad Innova One-Way"],
  ["Pune to Aurangabad Round Trip Innova", "Pune to Aurangabad Innova Car Hire"],
  ["Innova Cabs for Aurangabad Trip", "Affordable Aurangabad Innova Service"],
  ["Innova Taxi for Aurangabad from Pune", "Luxury Innova Cab to Aurangabad"],
  ["Group Booking for Aurangabad Innova", "Pune to Aurangabad One-Way Taxi"],
  ["Aurangabad Temple Innova Tour", "Innova for Aurangabad Travel"],
  ["Pune to Aurangabad Innova Booking", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we prioritize punctuality and reliability. Whether you’re traveling for business or leisure, our experienced drivers ensure that your journey from Pune to Aurangabad is timely, efficient, and comfortable. You can count on us for a hassle-free and stress-free trip."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs are perfect for long journeys like Pune to Aurangabad. With spacious seating, ample legroom, air conditioning, and modern amenities, you’ll enjoy a comfortable ride throughout the journey. It’s ideal for families, business groups, or anyone traveling with extra luggage."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are not only skilled in long-distance travel but are also familiar with the best routes from Pune to Aurangabad. They prioritize safety and customer satisfaction, ensuring that you have a smooth and secure ride. Their courteous and professional demeanor will make your trip even more enjoyable."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your trip from Pune to Aurangabad. There are no hidden charges, and you’ll get a clear breakdown of all costs up front, making it easy to manage your travel budget."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "We value your safety and comfort. Our Toyota Innova cabs come equipped with modern safety features such as airbags, seat belts, and GPS tracking to ensure a safe journey. You can relax and enjoy the trip knowing that we have your safety covered."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, ensuring that you can book your cab for any time of the day or night. Whether you’re planning an early morning trip or a late-night return, our team is ready to accommodate your travel needs to and from Aurangabad."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Aurangabad Innova cab is easy and quick. You can book online through our website or mobile app, or you can contact our customer service team for assistance. We make the booking process smooth and convenient for you."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages to suit your preferences. Whether you need to stop for sightseeing along the way or have any special requests, we can tailor the journey to meet your needs. Let us know what you’re looking for, and we’ll make your trip extra special."
  }
]
























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova cab for Pune to Aurangabad?',
            answer: 'Booking your Innova cab is simple! You can reserve your ride online via our website or mobile app. Alternatively, you can contact our customer service team for personalized assistance.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova comfortably accommodates up to 6 passengers, making it perfect for family trips, group travel, or business journeys from Pune to Aurangabad.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel from Pune to Aurangabad?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and know the best routes from Pune to Aurangabad. They are also trained to ensure a smooth and safe ride, providing you with a comfortable and secure journey.',
          },
          {
            question: 'What payment options are available for booking the Innova?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments through our app, making it convenient for you to pay for your trip.',
          },
          {
            question: 'Can I book a round trip from Pune to Aurangabad?',
            answer: 'Yes, we can arrange a round trip for you. Just provide us with your return details, and we will make sure you have a smooth trip both ways.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you in advance, ensuring transparency in pricing.',
          },
          {
            question: 'Can I make extra stops on the way to Aurangabad?',
            answer: 'Yes, you can make extra stops for sightseeing or any other purpose. Simply inform us during the booking process, and we’ll ensure that your trip is tailored to your preferences.',
          },
          {
            question: 'What is the luggage allowance for the Innova cab?',
            answer: 'The Toyota Innova has ample space for standard luggage. If you have additional luggage or special requirements, please let us know when booking, and we’ll ensure your needs are met.',
          },
          {
            question: 'Is S9 Travels available for corporate travel to Aurangabad?',
            answer: 'Yes, we provide corporate travel services to and from Aurangabad. Whether it’s for business meetings, corporate events, or group travel, we ensure a comfortable and professional experience.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Aurangabad Innova ride?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable travel experience. With professional drivers, well-maintained vehicles, and transparent pricing, we guarantee a smooth journey for your trip from Pune to Aurangabad.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made our journey from Pune to Aurangabad so easy and comfortable. The Innova was spacious, and the driver was friendly and professional. We reached our destination on time, and the ride was smooth all the way. I’ll definitely use their service again!”',
        },
        {
          name: 'Mrs. Preeti Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We used S9 Travels for a family trip to Aurangabad. The vehicle was perfect for our group, and the driver was courteous and professional. The trip was enjoyable, and we arrived on time. Great service!”',
        },
      ];
         
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Aurangabad Innova Cab Service",
        "description": "Book an Innova cab from Pune to Aurangabad for a comfortable and hassle-free journey. One-way, round-trip, and group bookings available. Affordable and luxury options for your Aurangabad temple visit and sightseeing tour.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "1100"
        }
      };
      
     

    return (
        <div>
          <Helmet>
        <title>Pune to Aurangabad Innova Cab Service | Affordable & Comfortable Taxi Ride</title>
        <meta 
          name="description" 
          content="Book Pune to Aurangabad Innova taxi for a comfortable and luxurious journey. We offer one-way, round-trip, and group travel options. Affordable, private, and luxury Innova cabs available for Aurangabad temple tours and sightseeing." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoaurangabadinnovacab;